import { adjustedReturn } from './salesPriceAdjustments.mjs';
const money = n => Math.round((n + Number.EPSILON) * 100) / 100;
const price = item => item.wholesalePrice ?? item.price;
export function makeLineDiscount(item, total) {
  if (!Number.isFinite(total) || total < 0 || Math.abs(total - money(total)) > 1e-8
    || !Number.isFinite(item.subUnitQty) || !(item.subUnitQty > 0) || !Number.isFinite(price(item)) || total > money(item.subUnitQty * price(item))) throw Error('优惠总价需为不超过原价的非负金额，最多两位小数');
  return { total: money(total), quantity: item.subUnitQty, unitPrice: price(item), sku: item.sku, specName: item.specName || '', unit: item.subUnit };
}
export function discountNeedsConfirmation(item) {
  const d = item.lineDiscount;
  return !!d && (d.quantity !== item.subUnitQty || d.unitPrice !== price(item) || d.sku !== item.sku || d.specName !== (item.specName || '') || d.unit !== item.subUnit);
}
export function validateLineDiscount(item) {
  if (!item.lineDiscount) return;
  if (item.historicalImport) throw Error('历史核算行不能直接改优惠，请新增商品行');
  if (discountNeedsConfirmation(item)) throw Error('商品、数量、单位或单价已变化，请重新确认优惠总价');
  makeLineDiscount(item, item.lineDiscount.total);
}
export function pricedAmount(item) {
  if (!item.lineDiscount) return item.amount;
  return discountNeedsConfirmation(item) ? money(item.subUnitQty * price(item)) : item.lineDiscount.total;
}
export function discountRemark(item) {
  const d = item.lineDiscount;
  return d ? (discountNeedsConfirmation(item) ? '优惠待重新确认' : `优惠${money(money(d.quantity * d.unitPrice) - d.total)}元，实计${d.total}元`) : '';
}
// Each partial return gets its proportion in cents; the final return takes the remaining cents.
export function applyDiscountReturn(item, orderId, items, orders) {
  const adjusted = adjustedReturn(item, orderId, items, orders);
  if (adjusted) return adjusted;
  const a = item.aftercare;
  if (item.lineType !== 'return' || !a?.sourceOrderId) return a?.discountedSource ? { ...item, aftercare: { ...a, discountedSource: undefined } } : item;
  const original = orders.find(o => o.id === a.sourceOrderId)?.items[a.sourceLineIndex];
  if (!original?.lineDiscount) return a.discountedSource ? { ...item, aftercare: { ...a, discountedSource: undefined } } : item;
  validateLineDiscount(original);
  const other = [...orders.filter(o => o.id !== orderId).flatMap(o => o.items), ...items]
    .filter(i => i !== item && i.aftercare?.id !== a.id && i.lineType === 'return' && i.aftercare?.sourceOrderId === a.sourceOrderId && i.aftercare?.sourceLineIndex === a.sourceLineIndex);
  const usedQty = other.reduce((s,i) => s + i.subUnitQty, 0);
  const usedCents = other.reduce((s,i) => s + Math.round(i.amount * 100), 0);
  const cents = Math.round(original.lineDiscount.total * 100);
  const remainingQty = original.subUnitQty - usedQty;
  if (item.subUnitQty > remainingQty + 1e-6 || item.subUnitQty <= 0) throw Error('累计退货数量超过原单数量');
  const refund = Math.abs(item.subUnitQty - remainingQty) < 1e-6 ? cents - usedCents : Math.min(cents - usedCents, Math.round(cents * item.subUnitQty / original.subUnitQty));
  if (refund < 0) throw Error('累计退货金额超过优惠成交金额');
  return { ...item, lineDiscount: undefined, amount: refund / 100, aftercare: { ...a, discountedSource: { quantity: original.subUnitQty, total: original.lineDiscount.total } } };
}
